<template>

 	<div class="default-container">
        <bar-manut
            single-entity="Abertura e Fechamento do Caixa"
            @closeform="handleRetorna">
        </bar-manut>

        <div class="row">
            <div class="col-md-8">
                <fechar-caixa :index="index" @closeform="handleRetorna"></fechar-caixa>
            </div>
        </div>

    </div>

</template>

<script>
import fecharCaixa from './varejo-fecharcaixa-form'

export default {

    props: {
        index: '',
    },

    components: {
        fecharCaixa,
    },

    data () {
        return {
        }
    },

    computed: {
    },

    watch: {

    },

    filters: {

    },

    methods: {
        handleRetorna() {
            this.$emit('closeform')
        },
    },

    created () {
    },

    mounted () {

    }

}

</script>



<style>
</style>






// WEBPACK FOOTER //
// src/forms-varejo/varejo-controlecaixa-form.vue